import MinimalFooter from "components/MinimalFooter";
import MinimalHeader from "components/MinimalHeader";
import React, { Suspense } from "react";

interface MinimalLayoutProps {
  children: React.ReactNode;
}

const MinimalLayout: React.FC<MinimalLayoutProps> = ({ children }) => {
  return (
    <Suspense fallback={null}>
      <MinimalHeader />
      {children}
      <MinimalFooter />
    </Suspense>
  );
};

export default MinimalLayout;
